import { ChevronLeft, ChevronRight } from 'lucide-react';

interface PaginationBarProps {
  page: number;
  totalPages: number;
  perPage: number;
  onPageChange: (p: number) => void;
  onPerPageChange: (n: number) => void;
}

export default function PaginationBar({
  page, totalPages, perPage, onPageChange, onPerPageChange,
}: PaginationBarProps) {
  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-cargo-border">
      <div className="flex items-center gap-2 text-sm text-cargo-muted">
        <span>Rows per page:</span>
        <select
          value={perPage}
          onChange={(e) => onPerPageChange(Number(e.target.value))}
          className="pl-2 pr-7 py-1 rounded bg-cargo-panel border border-cargo-border text-cargo-text text-sm
                     outline-none focus:ring-0 focus:border-cargo-accent cursor-pointer"
        >
          {[10, 25, 50].map((n) => (
            <option key={n} value={n}>{n}</option>
          ))}
        </select>
      </div>
      <div className="flex items-center gap-3">
        <span className="text-sm text-cargo-muted">Page {page} of {totalPages}</span>
        <div className="flex gap-1">
          <button onClick={() => onPageChange(Math.max(1, page - 1))} disabled={page <= 1}
            className="p-1.5 rounded-lg text-cargo-muted hover:text-cargo-text hover:bg-cargo-panel disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
            <ChevronLeft className="w-4 h-4" />
          </button>
          <button onClick={() => onPageChange(Math.min(totalPages, page + 1))} disabled={page >= totalPages}
            className="p-1.5 rounded-lg text-cargo-muted hover:text-cargo-text hover:bg-cargo-panel disabled:opacity-30 disabled:cursor-not-allowed transition-colors">
            <ChevronRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
